import $ from 'jquery';
import '../vendors/slick';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}

$( '.c-article-card-slider' ).slick( {
	rtl: rtl,
	centerMode: true,
	centerPadding: '3.75rem',
	slidesToShow: 2,
	nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg width="1em" height="1em" viewBox="0 0 23 20" xmlns="http://www.w3.org/2000/svg"><g stroke="currentColor" fill="none" fill-rule="evenodd"><path d="M-13.5-13.5h46v46h-46z"/><path d="M11.848.011l9.9 9.9-9.193 9.192"/><path stroke-linecap="square" d="M20.5 9.5H.5"/></g></svg></button>',
	prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg width="1em" height="1em" viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg"><path stroke="currentColor" fill="transparent" d="M-10.5-12.5h46v46h-46z"/><g stroke="currentColor"><path fill="transparent" d="M11.555 1.011l-9.899 9.9 9.192 9.192"/><path stroke-linecap="square" d="M2.5 10.5h20"/></g></g></svg></button>',
	responsive: [
		{
			breakpoint: 550,
			settings: {
				slidesToShow: 1,
			},
		},
	],
} );
